/**
 * ACF 6.0 block - js entrypoint
 *
 * entry point for webpack, can import js scripts and create css files for block
 * @package hum-fse-6-blocks
 */

import "./scss/_social-share.scss";

document.addEventListener( 'DOMContentLoaded', function () {

  const shareBlocks = document.querySelectorAll( '.acf-block-social-share' );
  var userAgent     = navigator.userAgent || navigator.vendor || window.opera;

  shareBlocks.forEach((oneBlock) => {
    
    const shareButton = oneBlock.querySelector('.social-share__button-open');
    const shareDialog = oneBlock.querySelector('.social-share__dialog');
    const closeButton = oneBlock.querySelector('.social-share__button-close');
    const title       = document.title;
    let url           = document.querySelector('link[rel=canonical]') ? document.querySelector('link[rel=canonical]').href : document.location.href;
  
    shareButton.addEventListener('click', event => {
  
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if ( /iPad|iPhone|iPod/.test(userAgent) && navigator.share ) {
        navigator.share({
          title: title,
          url: url,
        })
        .catch(console.error);
  
      } else {
        shareDialog.classList.add('is-open');
        closeButton.classList.add('is-open');
      }
  
    });
  
    closeButton.addEventListener('click', event => {
      shareDialog.classList.remove('is-open');
      closeButton.classList.remove('is-open');
    });

    /* Set fallback share links (for non mobile)
    *
    * adds links to share button (class= .share + .platform)
    * https://css-tricks.com/simple-social-sharing-links/
    * https://codepen.io/adamcoti/pen/jVGWdG
    *
    */
    setShareLinks();

    function socialWindow(url) {
      var left   = (screen.width - 570) / 2;
      var top    = (screen.height - 570) / 2;
      var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
      // Setting 'params' to an empty string will launch
      // content in a new tab or window rather than a pop-up.
      // params = "";
      window.open(url,"NewWindow",params);
    }

    function setShareLinks() {

      var pageUrl   = encodeURIComponent(document.URL);
      var title     = encodeURIComponent(document.title);
      var subject   = "subject=" + title;
      var tweet     = encodeURIComponent(document.querySelector('meta[property="og:description"]').getAttribute("content"));
      var body      = "body=Bekijk%20dit%20artikel%20" + pageUrl;

      var facebook  = oneBlock.querySelector( '.share.facebook' );
      var linkedin  = oneBlock.querySelector( '.share.linkedin' );
      var twitter   = oneBlock.querySelector( '.share.twitter' );
      var email     = oneBlock.querySelector( '.share.email' );

      facebook.addEventListener('click', event => {
        url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
        socialWindow(url);
      });

      twitter.addEventListener('click', event => {
        url = "https://twitter.com/intent/tweet?url=" + pageUrl + "&text=" + tweet;
        socialWindow(url);
      });

      linkedin.addEventListener('click', event => {
        url = "https://www.linkedin.com/sharing/share-offsite/?url=" + document.URL;
        socialWindow(url);
      });

      email.addEventListener('click', event => {
        url = "mailto:?" + subject + "&" + body;
        socialWindow(url);
      });
    }

  });

});